import React from "react";

import _Calendar from "./Calendar.elm";
import { getJwt } from "utilities/authentication";
import styles from "./styles.scss";
import { Elm } from "components/Elm";
import getServerRootUrl, { getHaskellBackendUrl, getRustBackendUrl } from "utilities/getServerRootUrl";
import LoadingContainer from "components/LoadingContainer";

interface Props {
  userId?: string;
}
export default function Calendar({ userId: userId }: Props) {
  if (!userId) return <LoadingContainer />;
  return (
    <div className={styles.elmContainer}>
      <Elm
        src={_Calendar.Elm.Calendar}
        flags={{
          userId,
          jwt: getJwt(),
          serverUrl: `${getServerRootUrl()}/graphql`,
          haskellBackendBaseUrl: getHaskellBackendUrl(),
          rustBackendBaseUrl: getRustBackendUrl(),
        }}
      />
    </div>
  );
}
